export enum APPLY_TYPES {
  online = 1,
  internet = 2,
  telephone = 3,
}

export enum STATUS_TYPES {
  WAITING_TO_OPEN_IN_SYSTEM = 1,

  INFORMATION_WAS_PROVIDED = 2,

  FORWARDED_TO_EXPERT = 3,

  EXPERT_REPLY_WAS_RECEIVED = 4,

  UNKNOWN = 5,
  PARTIAL_HANDLING = 6,
}
